import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { getFacetConfigType, useSearchResultsConfig } from '@sitecore-search/react';
import { AccordionFacets } from '../../basePrimitives/AccordionFacets/index.js';
const SearchResultsAccordionFacets = React.forwardRef((props, forwardedRef) => {
    const { onFacetValueClick = () => { }, ...accordionProps } = props;
    const config = useSearchResultsConfig();
    return (_jsx(AccordionFacets, { ...accordionProps, ref: forwardedRef, onFacetValueClick: (args) => onFacetValueClick({
            ...args,
            type: getFacetConfigType(config, args.facetId),
        }) }));
});
export default SearchResultsAccordionFacets;
